module.exports = __webpack_public_path__ + "img/banner3_1_jp.92ee8d29.png";